/* Animazioni d'entrata della landing traversine. */
(function () {
  'use strict';
  if (window.__tlAnim) return;
  window.__tlAnim = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && Shopify.designMode) return;
  if (document.querySelector('[data-tl-anim="false"]')) return;

  var groups = [
    ['.tl-hero .tl-gallery', 'img', 0],
    ['.tl-hero .tl-info > *', '', 70],
    ['.tl-strip__item', '', 90],
    ['.tl-head', '', 0],
    ['.tl-spot__media', 'pop', 0],
    ['.tl-spot__col:not(.tl-spot__col--right) .tl-spot__item', 'left', 140],
    ['.tl-spot__col--right .tl-spot__item', 'right', 140],
    ['.tl-layerlist li', '', 110],
    ['.tl-row:not(.tl-row--flip) .tl-row__media', 'left', 0],
    ['.tl-row--flip .tl-row__media', 'right', 0],
    ['.tl-row__body .tl-h2', '', 0],
    ['.tl-checks li', '', 90],
    ['.tl-compare tbody tr', '', 80],
    ['.tl-calc__panel', 'pop', 0],
    ['.tl-stats > .tl-media', 'img', 0],
    ['.tl-stat', '', 140],
    ['.tl-size', '', 110],
    ['.tl-use', '', 110],
    ['.tl-steps li', '', 140],
    ['.tl-ba', '', 130],
    ['.tl-vid', '', 100],
    ['.tl-review', '', 120],
    ['.tl-faq details', '', 70],
    ['.tl-final__seal', 'pop', 0]
  ];

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      io.unobserve(en.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  function cleanup(e) {
    if (e.target !== this || e.propertyName !== 'transform' || !this.classList.contains('is-in')) return;
    this.classList.remove('tl-reveal', 'tl-reveal--left', 'tl-reveal--right', 'tl-reveal--pop', 'tl-reveal--img', 'is-in');
    this.style.removeProperty('--tl-d');
    this.removeEventListener('transitionend', cleanup);
  }

  function prepare(scope) {
    groups.forEach(function (g) {
      var seen = new Map();
      scope.querySelectorAll(g[0]).forEach(function (el) {
        if (el.dataset.tlAnimDone) return;
        el.dataset.tlAnimDone = '1';
        var parent = el.parentElement;
        var i = seen.get(parent) || 0;
        seen.set(parent, i + 1);
        el.classList.add('tl-reveal');
        if (g[1]) el.classList.add('tl-reveal--' + g[1]);
        if (g[2]) el.style.setProperty('--tl-d', Math.min(i * g[2], 700) + 'ms');
        el.addEventListener('transitionend', cleanup);
        io.observe(el);
      });
    });
  }

  function start() {
    var root = document.documentElement;
    root.classList.add('tl-anim');
    prepare(document);
    void root.offsetHeight;
    requestAnimationFrame(function () { root.classList.add('tl-anim-on'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
